<div class="maintenance-banner" *ngIf="isVisible">
    <div class="maintenance-content">
        <div class="banner-left">
            <mat-icon class="maintenance-icon">build</mat-icon>
            <div class="banner-text">
                <h3>System Maintenance</h3>
                <p>We're currently performing system maintenance. Please try again in a few minutes.</p>
            </div>
        </div>
        <div class="banner-right">
            <button mat-icon-button (click)="retry()" class="retry-btn">
                <mat-icon>refresh</mat-icon>
            </button>
            <button mat-icon-button (click)="close()" class="close-btn">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>